import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-situation-container" }

import { ref, watchEffect } from 'vue';
import userDetail from './components/user-detail.vue';
import remarks from './components/remarks.vue';
import orderDetail from './components/orderDetail.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    userDetail: {}
  },
  setup(__props: any) {

const props = __props

const userDetailObj = ref({})
watchEffect(()=>{
  userDetailObj.value = props.userDetail
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(userDetail, { userDetail: userDetailObj.value }, null, 8, ["userDetail"]),
    _createVNode(remarks, { userDetail: userDetailObj.value }, null, 8, ["userDetail"]),
    _createVNode(orderDetail, { userDetail: userDetailObj.value }, null, 8, ["userDetail"])
  ]))
}
}

})